export default __webpack_public_path__ + "static/media/logoweb.244732c4.svg";